export default "__VITE_ASSET__DxtsVt$E__"